import { useQuery } from 'react-query'
import { Container, Row, Col } from 'react-bootstrap'
import Spinner from '../../components/Spinner'

import RecordingGrid from '../../components/user/RecordingGrid'
import RecordingList from '../../components/user/RecordingList'
import { getRecordingList } from '../../api/api.cdlbt.co'

const Latest = () => {
  const latestList = useQuery({
    queryKey: ['recordingList'],
    queryFn: getRecordingList,
  })

  if (latestList.isLoading || latestList.isError) {
    return (
      <Container className='text-center'>
        <Spinner />
      </Container>
    )
  }

  return (
    <Container>
      <Row className='ps-3 pe-3 flex-row-reverse'>
        <Col className='ps-4 pe-4'>
          <div className='d-flex w-100 justify-content-between mt-3 mb-3'>
            <div>
              <h2 className='fw-bold'>Latest</h2>
            </div>
          </div>
          <div className='d-none d-md-block'>
            <RecordingGrid recordingList={latestList.data.slice(0, 60)} />
          </div>
          <div className='d-block d-md-none d-lg-none d-xl-none d-xxl-none'>
            <RecordingList recordingList={latestList.data.slice(0, 60)} />
          </div>
        </Col>
      </Row>
    </Container>
  )
}
export default Latest
